'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSvgInline = require('react-svg-inline');

var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);

var _normalizeCssUnit = require('normalize-css-unit');

var _normalizeCssUnit2 = _interopRequireDefault(_normalizeCssUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SVGDeviconInline = function SVGDeviconInline(_ref) {
  var className = _ref.className,
      iconSVG = _ref.iconSVG,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? null : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? null : _ref$height;

  return _react2.default.createElement(_reactSvgInline2.default, {
    component: 'div',
    classSuffix: '-devicon',
    className: className,
    svg: iconSVG,
    width: width ? (0, _normalizeCssUnit2.default)(width) : '',
    height: height ? (0, _normalizeCssUnit2.default)(height) : ''
  });
};

SVGDeviconInline.propTypes = {
  className: _propTypes2.default.string,
  iconSVG: _propTypes2.default.string.isRequired,
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

exports.default = SVGDeviconInline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-devicon/_base/SVGDeviconInline/SVGDeviconInline.js
// module id = 808
// module chunks = 0